import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useQuery from '../../hooks/useQuery';
import { useLazyQuery } from '@apollo/client';
import { GET_USER_INFO } from 'entites/user/get-user-info.graphql';
import { handleSetData } from 'utils/helpers/log-in-log-out/handleSetData';
import { handleLogOut } from 'utils/helpers/log-in-log-out/handleLogOut';
import { ampSetUserId, ampSetUserProperty } from 'utils/helpers/amplitude/amplitude';
import { USER_ROLE } from 'utils/enums/user-role.enum';
import { LOGIN_USER_V2 } from 'entites/user/login-user.graphql';
import { API_V2 } from 'constants/graphql';
import { Loader } from 'pages/WRITER/EditChapters/EditChaptersContent/Autosave/Loader';
import { client } from 'components/hoc/WithApollo';

const Authenticate = () => {
	const navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);
	const { type, access_token } = useQuery();
	const [getUserInfo] = useLazyQuery(GET_USER_INFO, {
		fetchPolicy: 'network-only',
	});

	const handleUserInfoGet = useCallback(async () => {
		setIsLoading(true);
		try {
			if (!access_token) {
				navigate('/auth/log-in');

				return;
			}

			const { data } = await client.mutate({
				mutation: LOGIN_USER_V2,
				context: {
					clientName: API_V2,
					headers: {
						Authorization: `Bearer ${access_token}`,
					},
				},
			});
			if (!data?.login?.success) {
				navigate('/auth/log-in');

				return;
			}
			const { data: userData } = await getUserInfo();

			if (userData.getUserInfo.isBlocked) {
				handleLogOut(false);

				navigate('/permission-denied', { state: { user_id: userData.getUserInfo.user_id } });
				return;
			}

			if (userData) {
				handleSetData({
					user_id: userData.getUserInfo.user_id,
					email: userData.getUserInfo.email,
					role: userData.getUserInfo.role,
				});

				if (userData.getUserInfo.role === USER_ROLE.WRITER
					|| userData.getUserInfo.role === USER_ROLE.SOURCER) {
					ampSetUserId(userData.getUserInfo.user_id);
					ampSetUserProperty('email', userData.getUserInfo.email);
				}
			}

			navigate('/', { state: { type } });
			return;
		} catch (error) {
			navigate('/auth/sign-in');
		}

		setIsLoading(false);
	}, [getUserInfo, navigate, type, access_token]);

	useEffect(() => {
		handleUserInfoGet();
	}, [handleUserInfoGet]);

	return (
		<>
			{isLoading && <Loader />}
		</>
	);
};

export default Authenticate;
